"use client";

import { CenteredDiscLayout, HeroAgentCardLayout } from "./Components";
import { useTranslations } from "next-intl";
import * as m from "motion/react-m";
import { OrbWithMessages } from "@ui/components/core/Orb/OrbWithMessages";
import { CallAgentPillButton, GetCallPillButton } from "./AgentActionButtons";

export interface AgentInfoViewProps {
  callAgentButtonText?: string | null;
  getCallButtonText?: string | null;
  onCallAgent: () => void;
  onGetCall: () => void;
  discLayoutId?: string;
}

export function AgentInfoView({
  callAgentButtonText,
  getCallButtonText,
  onCallAgent,
  onGetCall,
  discLayoutId,
}: AgentInfoViewProps) {
  const t = useTranslations("ClientKeys.hero_agent.views.agent_info");

  return (
    <HeroAgentCardLayout width='lg' className='tw-flex tw-flex-col tw-justify-center'>
      <CenteredDiscLayout>
        <m.div layoutId={discLayoutId} className='tw-size-full tw-flex tw-flex-col tw-justify-center tw-items-center'>
          <OrbWithMessages
            texture='agents-1'
            alignMessages='top'
            messages={[
              {
                id: 1,
                message: t("initial_message"),
                role: "agent",
              },
            ]}
          />
        </m.div>
      </CenteredDiscLayout>

      <div className='tw-flex tw-items-center tw-justify-center tw-gap-10 tw-pt-8'>
        <CallAgentPillButton onClick={onCallAgent} label={callAgentButtonText} />
        <GetCallPillButton onClick={onGetCall} label={getCallButtonText} />
      </div>
    </HeroAgentCardLayout>
  );
}
